import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import {
  getRecaptchaResponse,
  getRecaptchaSiteKey,
  loadRecaptchaScript,
  renderRecaptchaWidget,
  resetRecaptchaWidget
} from '../utils/recaptcha';

const RecaptchaCheckbox = forwardRef(function RecaptchaCheckbox(_, ref) {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);

  useImperativeHandle(ref, () => ({
    getValue: () => getRecaptchaResponse(widgetIdRef.current),
    reset: () => resetRecaptchaWidget(widgetIdRef.current)
  }));

  useEffect(() => {
    if (!getRecaptchaSiteKey()) {
      return undefined;
    }

    let cancelled = false;

    loadRecaptchaScript()
      .then(() => new Promise((resolve) => {
        if (window.grecaptcha?.ready) {
          window.grecaptcha.ready(resolve);
        } else {
          resolve();
        }
      }))
      .then(() => {
        if (cancelled || !containerRef.current || widgetIdRef.current !== null) {
          return;
        }
        widgetIdRef.current = renderRecaptchaWidget(containerRef.current);
      })
      .catch((error) => {
        console.warn('reCAPTCHA script failed to load:', error);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (!getRecaptchaSiteKey()) {
    return null;
  }

  return <div ref={containerRef} className="flex justify-center min-h-[78px]" />;
});

export default RecaptchaCheckbox;
